import { gql } from "@apollo/client";

/** origin côté API : SHOPIFY | DJELIBA | APP (nullable ; défaut serveur DJELIBA). Ici on force APP. */
export const CREATE_ORDER = gql`
  mutation createOrder(
    $products: [OrderItemInput!]!
    $phone: String!
    $address: String
    $calling_code: String!
    $firstname: String
    $lastname: String
    $country_flag: String
    $amount: Float
    $isDeliveryFree: Boolean
    $sessionId: String
  ) {
    createOrder(
      createOrderInput: {
        calling_code: $calling_code
        products: $products
        phone: $phone
        address: $address
        firstname: $firstname
        lastname: $lastname
        country_flag: $country_flag
        amount: $amount
        isDeliveryFree: $isDeliveryFree
        sessionId: $sessionId
        origin: "APP"
      }
    ) {
      _id
      products {
        product {
          _id
          name
          price
          shop {
            name
          }
          images {
            lg
          }
        }
        quantity
      }
      createdAt
      amount
      address
      state
      status
    }
  }
`;

export const CANCEL_ORDER = gql`
  mutation cancelOrder($id: ID!) {
    cancelOrder(id: $id) {
      _id
      amount
    }
  }
`;
